import { Business, Organization, useCartAuthStore } from '@cartdotcom/auth'
import { MouseEvent } from 'react'

export const SUPPORT_EMAIL = 'channels@cart.com'
export const SUPPORT_EMAIL_SUBJECT = 'Brand Console support request'

interface SupportMailtoParams {
  email?: string
  organization?: Pick<Organization, 'id' | 'name'>
  business?: Pick<Business, 'id' | 'name'>
  pathname?: string
}

const formatEntity = (entity?: { id: number; name: string }) =>
  entity && `${entity.name} (${entity.id})`

/**
 * Builds a mailto link to Cart.com support, pre-filled with the user's context.
 * Uses encodeURIComponent rather than URLSearchParams, which encodes spaces as "+".
 */
export const buildSupportMailto = ({
  email,
  organization,
  business,
  pathname,
}: SupportMailtoParams) => {
  const contextLines = [
    ['User', email],
    ['Organization', formatEntity(organization)],
    ['Business', formatEntity(business)],
    ['Page', pathname],
  ]
    .filter(([, value]) => value)
    .map(([label, value]) => `${label}: ${value}`)

  const body = ['', '', ...contextLines].join('\r\n')

  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    SUPPORT_EMAIL_SUBJECT,
  )}&body=${encodeURIComponent(body)}`
}

export const openSupportEmail = (event?: MouseEvent) => {
  event?.preventDefault()
  const { email, currentOrganization, currentBusiness } = useCartAuthStore.getState()
  window.location.assign(
    buildSupportMailto({
      email,
      organization: currentOrganization,
      business: currentBusiness,
      pathname: window.location.pathname,
    }),
  )
}
